// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/***********************
* GLOBAL COLOR TOKENS * 
***********************/
/*
	General styles
*/
.Editor-module__editorToolbar--eTXJ2 {
  width: 100%;
  height: 0;
  position: relative;
  z-index: 1;
}

.Editor-module__editor--uzy_j {
  height: calc(100% - var(--editor-header-height));
  flex-grow: 1;
  border-top: 1px solid var(--editor-border-color);
}
.Editor-module__editor--uzy_j > div {
  height: 100%;
}

.Editor-module__icon--PlZsu {
  height: 1.25rem;
}

/*
	File tab styles
*/
.Editor-module__fileTabContainer--XfBhX {
  flex-shrink: 0;
  scrollbar-width: 0;
  display: flex;
  align-items: center;
  height: 3rem;
  width: calc(100% - 2rem);
  gap: 0.125rem;
  max-width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
}

.Editor-module__fileTabContainer--XfBhX::-webkit-scrollbar {
  height: 0;
  background: transparent;
}

.Editor-module__tabButtonWrapper--PPB23 {
  display: inline-flex;
  height: 3rem;
  padding: 10px 2px;
  justify-content: center;
  align-items: center;
  flex-shrink: 1;
  overflow: hidden;
  border-top: 0.1875rem solid transparent;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s;
}
.Editor-module__tabButtonWrapper--PPB23.Editor-module__newFileTab--kLwkB {
  height: 2.25rem;
  width: 2.25rem;
  min-width: 2.25rem;
  background-color: var(--transparent);
  border: var(--button-border-width) solid var(--transparent);
}
.Editor-module__tabButtonWrapper--PPB23.Editor-module__newFileTab--kLwkB:focus {
  border-color: #1c4ed8;
}
.Editor-module__tabButtonWrapper--PPB23 > button.Editor-module__tabButtonContent--wpYac {
  height: 2.25rem;
  min-width: 3rem;
  width: 8rem;
  gap: 6px;
  display: flex;
  justify-content: left;
  align-items: center;
  container-type: inline-size;
  padding: 0.5rem 0.375rem;
  font-size: 1rem;
  font-weight: 400;
  font-family: var(--font-family);
  text-overflow: ellipsis;
  color: var(--tab-button-text-color);
  background-color: var(--transparent);
  border-radius: 0.5rem;
  pointer-events: none;
}
.Editor-module__tabButtonWrapper--PPB23 > button.Editor-module__tabButtonContent--wpYac.Editor-module__newFileTab--kLwkB {
  justify-content: center;
}
.Editor-module__tabButtonWrapper--PPB23 > button.Editor-module__tabButtonContent--wpYac > .Editor-module__tabButtonText--W9CAk {
  flex-shrink: 2;
  max-width: 80%;
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  pointer-events: initial;
}
.Editor-module__tabButtonWrapper--PPB23 > button.Editor-module__tabButtonContent--wpYac > .Editor-module__fileIcon--Q2Cpx {
  width: 1rem;
}
@container (max-width: 4rem) {
  .Editor-module__tabButtonWrapper--PPB23 > button.Editor-module__tabButtonContent--wpYac > .Editor-module__fileIcon--Q2Cpx {
    display: none;
  }
}
.Editor-module__tabButtonWrapper--PPB23:hover {
  background-color: var(--tab-button-secondary-color);
}
.Editor-module__tabButtonWrapper--PPB23.Editor-module__tabButtonWrapperFocused--mFIc9 {
  background-color: var(--tab-button-secondary-color);
  border-top: 0.1875rem solid var(--tab-button-tertiary-color);
  border-radius: 4px 4px 0px 0px;
}
.Editor-module__tabButtonWrapper--PPB23.Editor-module__tabButtonWrapperFocused--mFIc9 > button.Editor-module__tabButtonContent--wpYac {
  color: var(--tab-button-tertiary-color);
}

button.Editor-module__closeTabButton--aZeMv {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 1.25rem;
  height: 1.25rem;
  flex-shrink: 0;
  padding: 0;
  background-color: var(--transparent);
  transition: background-color 0.3s, box-shadow 0.3s;
  color: var(--close-tab-button-color);
}
button.Editor-module__closeTabButton--aZeMv:hover {
  background-color: var(--close-tab-button-hover-color);
}

.Editor-module__tabDivider--G85qJ {
  height: 1.5rem;
  border: 1px solid var(--tab-divider-color);
}

.Editor-module__hiddenTabDivider--QaAQO {
  height: 1.5rem;
  border: 1px solid transparent;
}

/*
	Feature-flagged element styles
*/
button.Editor-module__resetButton--wKCqC {
  font-size: var(--theater-button-font-size);
  padding: var(--theater-button-padding);
  color: var(--background-color);
  background-color: var(--theater-tertiary-button-background-color);
  border-radius: var(--theater-button-border-radius);
  transition: background-color 0.3s, color 0.3s, width 0.3s;
  width: 5.5rem;
  height: 2.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

button.Editor-module__resetButton--wKCqC:hover {
  color: var(--theater-tertiary-button-background-color);
  background-color: var(--background-color);
}

.Editor-module__errorFont--SMTzv {
  font-size: 1rem;
  font-weight: 400;
  font-family: var(--font-family);
  color: var(--error-color);
}`, "",{"version":3,"sources":["webpack://./src/_variables.scss","webpack://./src/components/CodeEditor/Editor.module.scss"],"names":[],"mappings":"AAAA;;uBAAA;ACEA;;CAAA;AAGA;EACC,WAAA;EACA,SAAA;EACA,kBAAA;EACA,UAAA;AAED;;AAAA;EAEC,gDAAA;EACA,YAAA;EACA,gDAAA;AAED;AACC;EACC,YAAA;AACF;;AAEA;EACC,eAAA;AACD;;AAEA;;CAAA;AAIA;EACC,cAAA;EAEA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,wBAAA;EAEA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAFD;;AAKA;EACC,SAAA;EACA,uBAAA;AAFD;;AAKA;EAEC,oBAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EAGA,uCAAA;EACA,kBAAA;EAEA,eAAA;EACA,6CACC;AAPF;AAUC;EACC,eAAA;EACA,cAAA;EACA,kBAAA;EAGA,oCAAA;EAGA,2DAAA;AAZF;AAaE;EACC,qBAAA;AAXH;AAgBC;EAEC,eAAA;EACA,eAAA;EACA,WAAA;EACA,QAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EAEA,wBAAA;EAGA,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,uBAAA;EACA,mCAAA;EAGA,oCAAA;EACA,qBAAA;EACA,oBAAA;AApBF;AAsBE;EACC,uBAAA;AApBH;AAuBE;EACC,cAAA;EACA,cAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,uBAAA;AArBH;AAwBE;EACC,WAAA;AAtBH;AAuBG;EAFD;IAGE,aAAA;EApBF;AACF;AAwBC;EACC,mDAAA;AAtBF;AAyBC;EACC,mDAAA;EACA,4DAAA;EACA,8BAAA;AAvBF;AAyBE;EACC,uCAAA;AAvBH;;AA4BA;EAEC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,UAAA;EAGA,oCAAA;EACA,kDACC;EAED,oCAAA;AA9BD;AAgCC;EACC,qDAAA;AA9BF;;AAkCA;EACC,cAAA;EACA,0CAAA;AA/BD;;AAkCA;EACC,cAAA;EACA,6BAAA;AA/BD;;AAkCA;;CAAA;AAKA;EACC,0CAAA;EACA,sCAAA;EACA,8BAAA;EACA,iEAAA;EACA,kDAAA;EACA,yDACC;EAGD,aAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AApCD;;AAuCA;EACC,sDAAA;EACA,yCAAA;AApCD;;AAuCA;EACC,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,yBAAA;AApCD","sourcesContent":["/***********************\n* GLOBAL COLOR TOKENS * \n***********************/\n$--neutral-00: #ffffff;\n$--neutral-50: #fafafa;\n$--neutral-100: #f4f4f5;\n$--neutral-200: #e4e4e7;\n$--neutral-300: #d4d4d8;\n$--neutral-400: #a1a1aa;\n$--neutral-500: #71717a;\n$--neutral-600: #52525b;\n$--neutral-700: #3f3f46;\n$--neutral-800: #27272a;\n$--neutral-900: #18181b;\n\n$--neutral-variant-00: #f8fafc;\n$--neutral-variant-50: #f1f5f9;\n$--neutral-variant-100: #e2e8f0;\n$--neutral-variant-200: #cbd5e1;\n$--neutral-variant-300: #b9c3d1;\n$--neutral-variant-400: #94a2b8;\n$--neutral-variant-500: #64738b;\n$--neutral-variant-600: #475569;\n$--neutral-variant-700: #334155;\n$--neutral-variant-800: #1e293b;\n$--neutral-variant-900: #0f172a;\n\n$--primary-00: #f7fbff;\n$--primary-50: #eff6ff;\n$--primary-100: #dbe9fe;\n$--primary-200: #bfdbfe;\n$--primary-300: #92c5fd;\n$--primary-400: #60a5fa;\n$--primary-500: #3c82f6;\n$--primary-600: #2463eb;\n$--primary-700: #1c4ed8;\n$--primary-800: #1d40ae;\n$--primary-900: #1f3a8a;\n\n$--secondary-00: #fcfffd;\n$--secondary-50: #ecfef6;\n$--secondary-100: #d1fae5;\n$--secondary-200: #a8f3d0;\n$--secondary-300: #6ee7b7;\n$--secondary-400: #34d399;\n$--secondary-500: #12b981;\n$--secondary-600: #079669;\n$--secondary-700: #047857;\n$--secondary-800: #076046;\n$--secondary-900: #064e3b;\n\n$--error-00: #fffdfd;\n$--error-50: #fef2f2;\n$--error-100: #fee2e1;\n$--error-200: #fecaca;\n$--error-300: #fda5a5;\n$--error-400: #f87171;\n$--error-500: #ef4444;\n$--error-600: #dc2625;\n$--error-700: #b91c1b;\n$--error-800: #991b1b;\n$--error-900: #7f1c1d;\n","@import \"../../variables\";\n\n/*\n\tGeneral styles\n*/\n.editorToolbar {\n\twidth: 100%;\n\theight: 0;\n\tposition: relative;\n\tz-index: 1;\n}\n.editor {\n\t// Leave room for the editor header, otherwise CodeMirror will overflow\n\theight: calc(100% - var(--editor-header-height));\n\tflex-grow: 1;\n\tborder-top: 1px solid var(--editor-border-color);\n\n\t// Fix React CodeMirror height in certain cases\n\t& > div {\n\t\theight: 100%;\n\t}\n}\n.icon {\n\theight: 1.25rem;\n}\n\n/*\n\tFile tab styles\n*/\n\n.fileTabContainer {\n\tflex-shrink: 0;\n\n\tscrollbar-width: 0;\n\tdisplay: flex;\n\talign-items: center;\n\theight: 3rem;\n\twidth: calc(100% - 2rem);\n\n\tgap: 0.125rem;\n\tmax-width: 100%;\n\toverflow-x: auto;\n\toverflow-y: hidden;\n}\n\n.fileTabContainer::-webkit-scrollbar {\n\theight: 0;\n\tbackground: transparent;\n}\n\n.tabButtonWrapper {\n\t// Layout\n\tdisplay: inline-flex;\n\theight: 3rem;\n\tpadding: 10px 2px;\n\tjustify-content: center;\n\talign-items: center;\n\tflex-shrink: 1;\n\toverflow: hidden;\n\n\t// Style\n\tborder-top: 0.1875rem solid transparent;\n\tborder-radius: 8px;\n\n\tcursor: pointer;\n\ttransition:\n\t\tbackground-color 0.3s,\n\t\tcolor 0.3s;\n\n\t&.newFileTab {\n\t\theight: 2.25rem;\n\t\twidth: 2.25rem;\n\t\tmin-width: 2.25rem;\n\n\t\t// Style\n\t\tbackground-color: var(--transparent);\n\n\t\t// Cancel out \"selected\" border on other tab buttons\n\t\tborder: var(--button-border-width) solid var(--transparent);\n\t\t&:focus {\n\t\t\tborder-color: #{$--primary-700};\n\t\t}\n\t}\n\n\t// A lot of duplicate CSS to overwrite native browser button styles\n\t> button.tabButtonContent {\n\t\t// Layout\n\t\theight: 2.25rem;\n\t\tmin-width: 3rem;\n\t\twidth: 8rem;\n\t\tgap: 6px;\n\t\tdisplay: flex;\n\t\tjustify-content: left;\n\t\talign-items: center;\n\t\tcontainer-type: inline-size;\n\n\t\tpadding: 0.5rem 0.375rem;\n\n\t\t// Typography\n\t\tfont-size: 1rem;\n\t\tfont-weight: 400;\n\t\tfont-family: var(--font-family);\n\t\ttext-overflow: ellipsis;\n\t\tcolor: var(--tab-button-text-color);\n\n\t\t// Style\n\t\tbackground-color: var(--transparent);\n\t\tborder-radius: 0.5rem;\n\t\tpointer-events: none;\n\n\t\t&.newFileTab {\n\t\t\tjustify-content: center;\n\t\t}\n\n\t\t> .tabButtonText {\n\t\t\tflex-shrink: 2;\n\t\t\tmax-width: 80%;\n\t\t\tdisplay: block;\n\t\t\twhite-space: nowrap;\n\t\t\toverflow: hidden;\n\t\t\ttext-overflow: ellipsis;\n\t\t\tpointer-events: initial; // reset to allow for pointer events on text\n\t\t}\n\n\t\t> .fileIcon {\n\t\t\twidth: 1rem;\n\t\t\t@container (max-width: 4rem) {\n\t\t\t\tdisplay: none; // Hide file icon when tab width is too small\n\t\t\t}\n\t\t}\n\t}\n\n\t&:hover {\n\t\tbackground-color: var(--tab-button-secondary-color);\n\t}\n\n\t&.tabButtonWrapperFocused {\n\t\tbackground-color: var(--tab-button-secondary-color);\n\t\tborder-top: 0.1875rem solid var(--tab-button-tertiary-color);\n\t\tborder-radius: 4px 4px 0px 0px;\n\n\t\t> button.tabButtonContent {\n\t\t\tcolor: var(--tab-button-tertiary-color);\n\t\t}\n\t}\n}\n\nbutton.closeTabButton {\n\t// Layout\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\twidth: 1.25rem;\n\theight: 1.25rem;\n\tflex-shrink: 0;\n\tpadding: 0;\n\n\t// Style\n\tbackground-color: var(--transparent);\n\ttransition:\n\t\tbackground-color 0.3s,\n\t\tbox-shadow 0.3s;\n\tcolor: var(--close-tab-button-color);\n\n\t&:hover {\n\t\tbackground-color: var(--close-tab-button-hover-color);\n\t}\n}\n\n.tabDivider {\n\theight: 1.5rem;\n\tborder: 1px solid var(--tab-divider-color);\n}\n\n.hiddenTabDivider {\n\theight: 1.5rem;\n\tborder: 1px solid transparent;\n}\n\n/*\n\tFeature-flagged element styles\n*/\n\n// Flag: showExtraButtons\nbutton.resetButton {\n\tfont-size: var(--theater-button-font-size);\n\tpadding: var(--theater-button-padding);\n\tcolor: var(--background-color);\n\tbackground-color: var(--theater-tertiary-button-background-color);\n\tborder-radius: var(--theater-button-border-radius);\n\ttransition:\n\t\tbackground-color 0.3s,\n\t\tcolor 0.3s,\n\t\twidth 0.3s;\n\twidth: 5.5rem;\n\theight: 2.25rem;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\nbutton.resetButton:hover {\n\tcolor: var(--theater-tertiary-button-background-color);\n\tbackground-color: var(--background-color);\n}\n\n.errorFont {\n\tfont-size: 1rem;\n\tfont-weight: 400;\n\tfont-family: var(--font-family);\n\tcolor: var(--error-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"editorToolbar": `Editor-module__editorToolbar--eTXJ2`,
	"editor": `Editor-module__editor--uzy_j`,
	"icon": `Editor-module__icon--PlZsu`,
	"fileTabContainer": `Editor-module__fileTabContainer--XfBhX`,
	"tabButtonWrapper": `Editor-module__tabButtonWrapper--PPB23`,
	"newFileTab": `Editor-module__newFileTab--kLwkB`,
	"tabButtonContent": `Editor-module__tabButtonContent--wpYac`,
	"tabButtonText": `Editor-module__tabButtonText--W9CAk`,
	"fileIcon": `Editor-module__fileIcon--Q2Cpx`,
	"tabButtonWrapperFocused": `Editor-module__tabButtonWrapperFocused--mFIc9`,
	"closeTabButton": `Editor-module__closeTabButton--aZeMv`,
	"tabDivider": `Editor-module__tabDivider--G85qJ`,
	"hiddenTabDivider": `Editor-module__hiddenTabDivider--QaAQO`,
	"resetButton": `Editor-module__resetButton--wKCqC`,
	"errorFont": `Editor-module__errorFont--SMTzv`
};
export default ___CSS_LOADER_EXPORT___;
